/**
 * <s-ticker data-interval="4500"> — shows one [data-msg] child at a time and cycles through them.
 * The active message carries [data-active]; markup styles the transition. Pauses while hovered or focused,
 * and when the tab is hidden. With a single message it does nothing.
 */
class STicker extends HTMLElement {
  #timer;
  #index = 0;
  #paused = false;

  connectedCallback() {
    this.messages = [...this.querySelectorAll('[data-msg]')];
    if (this.messages.length < 2) return;
    this.#index = Math.max(0, this.messages.findIndex((msg) => msg.hasAttribute('data-active')));
    const pause = () => { this.#paused = true; };
    const resume = () => { this.#paused = false; };
    this.addEventListener('pointerenter', pause);
    this.addEventListener('pointerleave', resume);
    this.addEventListener('focusin', pause);
    this.addEventListener('focusout', resume);
    const interval = Number(this.dataset.interval) || 4500;
    this.#timer = window.setInterval(() => {
      if (this.#paused || document.hidden) return;
      this.show((this.#index + 1) % this.messages.length);
    }, interval);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
  }

  show(index) {
    const current = this.messages[this.#index];
    current?.removeAttribute('data-active');
    current?.setAttribute('aria-hidden', 'true');
    current?.setAttribute('tabindex', '-1');
    this.#index = index;
    const next = this.messages[index];
    next.setAttribute('data-active', '');
    next.removeAttribute('aria-hidden');
    next.removeAttribute('tabindex');
  }
}

if (!customElements.get('s-ticker')) customElements.define('s-ticker', STicker);
